import React, { Component } from "react";
import { Fragment } from "react";
import offImage from './images/off.png';
import Loading from "./loader";
import QuestionNavigator from "./QuestionNavigator";
import { ArrowLeftOutlined } from "@ant-design/icons";
import ScrollUpButton from "react-scroll-up-button";
import StateWarning from './StateWarning';

class VoteOneResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      detailsVisible: [],
      mainMeeting: [],
      agenda: [],
      questionDetail: {},
      voteCount: [],
      isLoading: true,
      inputValues: {},
      votes: {},
      votesMap: {},
      detailsMap: {},
      emptyVotes: false,
      showScrollUp: false,
      isOverlapped: false,
      labelsLeft: 0,
      columnWidths: [80, 80, 80]
    };
    this.processVoteCount = this.processVoteCount.bind(this);
  }

  processVoteCount(voteCount) {
    const votesResult = {};
    if (Array.isArray(voteCount)) {
      voteCount.forEach(item => {
        if (item?.json_quantity?.VoteDtls?.VoteInstrForAgndRsltn) {
          item.json_quantity.VoteDtls.VoteInstrForAgndRsltn.forEach(vote => {
            const { Quantity, DetailId, QuestionId } = vote.VoteInstr;
            if (!votesResult[QuestionId]) {
              votesResult[QuestionId] = {};
            }
            votesResult[QuestionId][DetailId] = [vote.VoteInstr.Vote, Quantity];
          });
        }
      });
    }
    return votesResult;
  }

  processVotesData(resData, agenda) {
    const votes = {};
    const inputValues = {};

    if (
      !resData ||
      !Array.isArray(resData) ||
      resData.length === 0 ||
      !resData[0]?.json_result?.VoteDtls?.VoteInstrForAgndRsltn
    ) {
      console.warn('Нет данных для обработки');
      return { votes, inputValues };
    }

    const items = resData[0].json_result.VoteDtls.VoteInstrForAgndRsltn;

    const processVote = (voteType) => {
      if (!voteType) return '';
      const { Quantity, Numerator, Denominator } = voteType;
      if (Numerator !== undefined && Denominator !== undefined) {
        return Quantity !== undefined
          ? `${Quantity} ${Numerator}/${Denominator}`
          : `${Numerator}/${Denominator}`;
      }
      return Quantity !== undefined ? String(Quantity) : '';
    };

    items.forEach(item => {
      const { QuestionId, DetailId, For, Against, Abstn } = item.VoteInstr;
      const voteValue = For
        ? ['За', processVote(For)]
        : Against
          ? ['Против', processVote(Against)]
          : Abstn
            ? ['Воздержался', processVote(Abstn)]
            : null;

      if (!voteValue) return;

      if (!votes[QuestionId]) {
        votes[QuestionId] = {};
      }

      if (DetailId) {
        votes[QuestionId][DetailId] = voteValue;
        if (this.isCumulativeQuestion(QuestionId, agenda)) {
          if (!inputValues[QuestionId]) {
            inputValues[QuestionId] = {};
          }
          inputValues[QuestionId][DetailId] = voteValue[1];
        }
      } else {
        votes[QuestionId] = voteValue;
      }
    });

    return { votes, inputValues };
  }

  isCumulativeQuestion(questionId, agenda) {
    if (!agenda || !Array.isArray(agenda)) return false;
    const question = agenda.find(item => item.question_id === parseInt(questionId, 10));
    return !!question?.cumulative;
  }

  handleInputChange(questionId, detailId, event) {
    const { inputValues } = this.state;
    const value = event.target.value;

    this.setState(prevState => ({
      inputValues: {
        ...prevState.inputValues,
        [questionId]: {
          ...prevState.inputValues[questionId],
          [detailId]: value,
        },
      },
    }));
  }

  async componentDidMount() {
    const { match } = this.props;
    const meetingId = match.params.meetingId;
    const selectedAccountId = match.params.selectedAccountId;
    const selectedUniquifier = match.params.selectedUniquifier;
    const voteCountId = match.params.voteCountId;
    const isAdminView = !!voteCountId;

    const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

    window.addEventListener('scroll', this.handleScroll);

    let anketaUrl = `${API_ADDRESS}get_vote_anketa/${meetingId}/${selectedAccountId}/${selectedUniquifier}`;
    if (isAdminView) {
      anketaUrl = `${API_ADDRESS}get_vote_anketa_admin/${meetingId}/?account_id=${selectedAccountId}&uniquifier=${selectedUniquifier}&vote_count_id=${voteCountId}`;
    }

    try {
      const userRes = await fetch(anketaUrl, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!userRes.ok) {
        this.setState({ isLoading: false });
        alert("Произошла ошибка. Попробуйте еще раз.");
        this.props.history.goBack();
        return;
      }

      const AnketaData = await userRes.json();

      if (!AnketaData.agenda || AnketaData.agenda.length === 0) {
        this.setState({
          isLoading: false,
          emptyVotes: true,
          mainMeeting: AnketaData.mainMeeting,
          agenda: []
        }, () => {
          this.setupObserver();
          this.updateColumnWidths();
          window.addEventListener('resize', this.updateColumnWidths);
        });
        return;
      }

      let resVotesUrl = `${API_ADDRESS}get_current_res_votes/${meetingId}/${selectedAccountId}/${selectedUniquifier}/`;
      if (isAdminView) {
        resVotesUrl = `${API_ADDRESS}get_current_res_votes_admin/${meetingId}/?account_id=${selectedAccountId}&uniquifier=${selectedUniquifier}&vote_count_id=${voteCountId}`;
      }

      const ResVotes = await fetch(resVotesUrl, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });

      if (!ResVotes.ok) {
        console.error('Ошибка загрузки результатов:', ResVotes.statusText);
        this.setState({ isLoading: false });
        return;
      }

      const resData = await ResVotes.json();

      const hasValidResults = Array.isArray(resData) && resData.some(item =>
        item?.json_result?.VoteDtls?.VoteInstrForAgndRsltn?.length > 0
      );

      if (!hasValidResults) {
        const sortedAgenda = [...AnketaData.agenda].sort((a, b) => parseInt(a.question_id, 10) - parseInt(b.question_id, 10));
        this.setState({
          agenda: sortedAgenda,
          mainMeeting: AnketaData.mainMeeting,
          isLoading: false,
          emptyVotes: true,
        }, () => {
          this.setupObserver();
          this.updateColumnWidths();
          window.addEventListener('resize', this.updateColumnWidths);
        });
        return;
      }

      const sortedAgenda = [...AnketaData.agenda].sort((a, b) => parseInt(a.question_id, 10) - parseInt(b.question_id, 10));
      const { votes, inputValues } = this.processVotesData(resData, sortedAgenda);

      this.setState({
        agenda: sortedAgenda,
        voteCount: AnketaData.voteCount,
        mainMeeting: AnketaData.mainMeeting,
        votes: { ...this.processVoteCount(AnketaData.voteCount), ...votes },
        inputValues: { ...this.state.inputValues, ...inputValues },
        isLoading: false,
      }, () => {
        this.setupObserver();
        this.updateColumnWidths();
        window.addEventListener('resize', this.updateColumnWidths);
      });

    } catch (e) {
      console.error('Ошибка в VoteOneResult:', e);
      this.setState({ isLoading: false });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
    if (this.observer) {
      this.observer.disconnect();
    }
    window.removeEventListener('resize', this.updateColumnWidths);
  }

  setTableAnchorRef = (element) => {
    this.tableAnchorRef = element;
  };

  getCumulativeCount = (questionId) => {
    const { voteCount } = this.state;
    for (const vote of voteCount) {
      if (vote.json_quantity && vote.json_quantity.VoteDtls) {
        const { VoteInstrForAgndRsltn } = vote.json_quantity.VoteDtls;
        for (const item of VoteInstrForAgndRsltn) {
          const instr = item.VoteInstr;
          if (instr.QuestionId === questionId) {
            const { Quantity, Numerator, Denominator } = instr;
            if (Numerator !== undefined && Denominator !== undefined) {
              if (Quantity !== undefined) {
                return `${Quantity} ${Numerator}/${Denominator}`;
              } else {
                return `${Numerator}/${Denominator}`;
              }
            }
            if (Quantity !== undefined) {
              return `${Quantity}`;
            }
          }
        }
      }
    }
    return '0';
  };

  toggleDetail = async (questionId) => {
    const { detailsVisible } = this.state;
    const currentlyVisible = detailsVisible[questionId];

    this.setState(prevState => ({
      detailsVisible: {
        ...prevState.detailsVisible,
        [questionId]: !currentlyVisible
      },
      loading: true,
    }));

    if (!currentlyVisible) {
      const { match } = this.props;
      const meetingId = match.params.meetingId;
      const API_ADDRESS = process.env.REACT_APP_API_ADDRESS;

      try {
        const response = await fetch(`${API_ADDRESS}get_cumulatives/${meetingId}/${questionId}/`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (response.ok) {
          const questionsData = await response.json();
          const sortedQuestionDetail = [...questionsData.questionDetail].sort(
            (a, b) => a.detail_id - b.detail_id
          );
          this.setState(prevState => ({
            questionDetail: {
              ...prevState.questionDetail,
              [questionId]: sortedQuestionDetail,
            },
            loading: false,
          }));
        }
      } catch (e) {
        console.error(e);
        this.setState({ loading: false });
      }
    } else {
      this.setState({ loading: false });
    }
  };

  handleBackClick = () => {
    this.props.history.goBack();
  };

  highlightRow = (questionId) => {
    const row = document.getElementById(`question-${questionId}`);
    if (row) {
      row.classList.add('blink-animation');
      setTimeout(() => {
        row.classList.remove('blink-animation');
      }, 1000);
    }
  };

  handleScroll = () => {
    const showScrollUp = window.scrollY > 130;
    this.setState({ showScrollUp });
  };

  setupObserver = () => {
    if (!this.tableAnchorRef) return;
    if (this.observer) this.observer.disconnect();
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry) return;
        this.setState({ isOverlapped: !entry.isIntersecting });
      },
      {
        threshold: 0,
        rootMargin: '-80px 0px 0px 0px',
      }
    );
    this.observer.observe(this.tableAnchorRef);
  };

  updateColumnWidths = () => {
    const headers = document.querySelectorAll('.table-checkbox thead th.checkbox-column');
    if (headers.length === 3) {
      const rects = Array.from(headers).map(el => el.getBoundingClientRect());
      this.setState({
        columnWidths: rects.map(r => r.width),
        labelsLeft: rects[0].left,
      });
    }
  };

  render() {
    const { mainMeeting, agenda, questionDetail, voteCount, detailsVisible, isLoading, emptyVotes } = this.state;
    if (isLoading) {
      return <Loading />;
    }

    if (emptyVotes) {
      return (
        <div className="page-container">
          <div className="header-container">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
              <div className="back-button-wrapper" onClick={this.handleBackClick}>
                <ArrowLeftOutlined
                  style={{ fontSize: '20px', cursor: 'pointer', marginTop: '4px' }}
                />
              </div>
              <h1>Результат голосования</h1>
            </div>
          </div>
          <StateWarning message="Результаты голосования отсутствуют" />
        </div>
      );
    }

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const options = { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
      const formattedDate = date.toLocaleString('ru-RU', options);
      return formattedDate.replace(/ GMT.*/, '').replace(' года', '').trim();
    };

    return (
      <>
        <div className="page-container">
          <div className="header-container">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
              <div className="back-button-wrapper" onClick={this.handleBackClick}>
                <ArrowLeftOutlined
                  style={{ fontSize: '20px', cursor: 'pointer', marginTop: '4px' }}
                />
              </div>
              <h1>Результат голосования</h1>
            </div>
          </div>

          <div className="grid-container2">
            <p style={{ textAlign: 'center' }}><b>{mainMeeting.meeting_name}</b></p>
            <p style={{ textAlign: 'center', marginTop: '0' }}>
              <b>Акционерное общество "Ведение реестров компаний"</b>
            </p>

            <div className="row1">
              <label htmlFor="endDate">Дата, время окончания приёма бюллетеней:</label>
              <span className="whiteBox"><b>{formatDate(mainMeeting.deadline_date)} мск</b></span>
            </div>

            <span
              ref={this.setTableAnchorRef}
              style={{ display: 'inline-block', width: 0, height: 1 }}
            />

            <table className="table-checkbox">
              <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th className="checkbox-column">За</th>
                  <th className="checkbox-column">Против</th>
                  <th className="checkbox-column">Воздержался</th>
                </tr>
              </thead>
              <tbody>
                {agenda.map((item, index) => (
                  <Fragment key={item.question_id}>
                    <tr id={`question-${item.question_id}`}>
                      <td>{index + 1}</td>
                      <td>
                        <div style={{
                          marginTop: '10px',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center'
                        }}>
                          {item.cumulative && (
                            <div style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
                              <span>Количество кумулятивных голосов: </span>
                              <span className="greyBox" style={{ marginLeft: '5px' }}>
                                <b>{this.getCumulativeCount(item.question_id)}</b>
                              </span>
                            </div>
                          )}
                        </div>
                        <div style={{ marginTop: '15px' }}>
                          <i><b>Вопрос:</b></i> {item.question}
                        </div>
                        <div style={{ marginTop: '10px' }}>
                          <i><b>Решение:</b></i> {item.decision}
                        </div>
                        {(item.cumulative || (item.cumulative === false && item.seat_count > 0)) && (
                          <img
                            src={offImage}
                            alt={detailsVisible[item.question_id] ? 'Скрыть' : 'Развернуть'}
                            onClick={() => this.toggleDetail(item.question_id)}
                            className={`toggle-icon ${detailsVisible[item.question_id] ? 'rotated' : ''}`}
                            style={{ marginLeft: '5px', marginTop: '10px' }}
                          />
                        )}<br />
                      </td>
                      <td className="checkbox-column">
                        {item.cumulative ? null : (
                          <input
                            type="checkbox"
                            checked={this.state.votes[item.question_id] && this.state.votes[item.question_id][0] === 'За'}
                            disabled={(item.cumulative === false && item.seat_count > 0)}
                            readOnly
                          />
                        )}
                      </td>
                      <td className="checkbox-column">
                        <input
                          type="checkbox"
                          checked={this.state.votes[item.question_id] && this.state.votes[item.question_id][0] === 'Против'}
                          disabled={(item.cumulative === false && item.seat_count > 0)}
                          readOnly
                        />
                      </td>
                      <td className="checkbox-column">
                        <input
                          type="checkbox"
                          checked={this.state.votes[item.question_id] && this.state.votes[item.question_id][0] === 'Воздержался'}
                          disabled={(item.cumulative === false && item.seat_count > 0)}
                          readOnly
                        />
                      </td>
                    </tr>

                    {item.cumulative && detailsVisible[item.question_id] && questionDetail[item.question_id] && (
                      questionDetail[item.question_id].map((detail, detailIndex) => (
                        <tr key={detailIndex}>
                          <td></td>
                          <td style={{ paddingLeft: '100px' }}>{detail.detail_text}</td>
                          <td className="checkbox-column">
                            <input
                              type="text"
                              className="main-input7"
                              value={this.state.inputValues[item.question_id]?.[detail.detail_id] || ''}
                              onChange={(e) => this.handleInputChange(item.question_id, detail.detail_id, e)}
                              disabled={(this.state.votes[item.question_id]?.[0] === 'Против' ||
                                this.state.votes[item.question_id]?.[0] === 'Воздержался') && item.cumulative}
                              readOnly
                            />
                          </td>
                        </tr>
                      ))
                    )}

                    {item.cumulative === false && item.seat_count > 0 && detailsVisible[item.question_id] && questionDetail[item.question_id] && (
                      questionDetail[item.question_id].map((detail, detailIndex) => (
                        <tr key={detailIndex}>
                          <td></td>
                          <td style={{ paddingLeft: '100px' }}>{detail.detail_text}</td>
                          <td className="checkbox-column">
                            <input
                              type="checkbox"
                              checked={this.state.votes[item.question_id]?.[detail.detail_id]?.[0] === 'За'}
                              readOnly
                            />
                          </td>
                          <td className="checkbox-column">
                            <input
                              type="checkbox"
                              checked={this.state.votes[item.question_id]?.[detail.detail_id]?.[0] === 'Против'}
                              readOnly
                            />
                          </td>
                          <td className="checkbox-column">
                            <input
                              type="checkbox"
                              checked={this.state.votes[item.question_id]?.[detail.detail_id]?.[0] === 'Воздержался'}
                              readOnly
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </Fragment>
                ))}
              </tbody>
            </table>

            <QuestionNavigator
              questions={this.state.agenda.map(q => ({ ...q, question_id: q.question_id }))}
              onQuestionClick={this.highlightRow}
              showScrollUp={this.state.showScrollUp}
            />

            <div className="button-container5">
              <button2 className="button2" style={{ margin: '0 auto' }} onClick={this.handleBackClick}>
                <b>Назад</b>
              </button2>
            </div>

            <ScrollUpButton />

            {this.state.isOverlapped && (
              <div className="floating-labels">
                <div
                  className="floating-label show"
                  style={{
                    width: `${this.state.columnWidths[0] - 10}px`,
                    left: `${this.state.labelsLeft + 5}px`,
                  }}
                >
                  За
                </div>
                <div
                  className="floating-label show"
                  style={{
                    width: `${this.state.columnWidths[1] - 10}px`,
                    left: `${this.state.labelsLeft + this.state.columnWidths[0] + 5}px`,
                  }}
                >
                  Против
                </div>
                <div
                  className="floating-label show"
                  style={{
                    width: `${this.state.columnWidths[2] - 10}px`,
                    left: `${
                      this.state.labelsLeft +
                      this.state.columnWidths[0] +
                      this.state.columnWidths[1] +
                      5
                    }px`,
                  }}
                >
                  Воздержался
                </div>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default VoteOneResult;